import type { BrandModelMapping } from "@/lib/aspectRatioUtils/types";

export const brandsWithCustomModels: readonly string[] = [];

export const brandModelMapping: BrandModelMapping = {
  defaultModel: "nano_banana_pro",
  flowBrandMapping: {
    campaign: {
      brandSpecificModels: {},
    },
    lifestyle: {
      brandSpecificModels: {},
    },
    pdp: {
      brandSpecificModels: {},
    },
    assetgeneration: {
      brandSpecificModels: {},
    },
    videogeneration: {
      brandSpecificModels: {},
    },
    background: {
      brandSpecificModels: {},
    },
  },
};

export default brandModelMapping;
